import React from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import Button from "components/CustomButtons/Button.js";
import BanneImg from "assets/img/capuchin-illustration.png"
import "./style.scss";

export default function Banner() {
  const bg = {
    backgroundColor: `#392991`
  };
  return (
    <div className="banner">
      <Container>
        <Row>
          <Col lg={6} md={12} className="left-aside">
            <h1 className="text-bold">
              {" "}
              Welcome to Capuchin Custody of Nigeria{" "}
            </h1>
            <p>
              Do you feel deeply drawn to a life of intimacy with God? Would you
              love to imitate Jesus in his life of complete self-emptying
              (humility and poverty)?
            </p>
            <Button
              color="primary"
              variant="contained"
              component={Link}
              to="/learn-more"
              style={bg}
            >
              Learn More
            </Button>
          </Col>
          <Col lg={6} md={12} className="banner-img">
            <img src={BanneImg} alt="Banner-illustration" />
          </Col>
        </Row>
      </Container>
    </div>
  );
}
